module.exports = __webpack_public_path__ + "assets/setting_select.53c2c9f1.svg";